import React from 'react';
import { pxToRem } from '@withjoy/joykit/theme';
import { Box, ButtonV2, TextV2 } from '@withjoy/joykit';

type ConsoleEmptyStateProps = Readonly<{
  title: string;
  content: string;
  onReset?: () => void;
  resetButtonLabel: string;
  showResetButton?: boolean;
}>;

export const ConsoleEmptyState = ({ title, content, resetButtonLabel, onReset, showResetButton }: ConsoleEmptyStateProps) => (
  <Box
    paddingX={pxToRem(24)}
    paddingY={pxToRem(40)}
    width={{ _: 'full', md: pxToRem(821) }}
  >
    <TextV2 typographyVariant="hed5">{title}</TextV2>
    <TextV2
      marginTop={5}
      color="mono10"
      typographyVariant="body2"
    >
      {content}
    </TextV2>
    {showResetButton && (
      <ButtonV2
        marginTop={6}
        shape="rounded"
        intent="neutral"
        onClick={onReset}
        typographyVariant="button2"
      >
        {resetButtonLabel}
      </ButtonV2>
    )}
  </Box>
);
